import React from 'react';
import { Conversation, Text } from '@common/components';
import { Space } from 'antd';
import {
  CommentInfoFragmentType,
  SimpleFileFragmentType,
} from '@common/graphql';
import { ApprovalChainsAttachmentsDrawerTrigger } from '@approvals/components';

type Props = {
  id: string;
  approvalDocument?: SimpleFileFragmentType | null;
  actionType: keyof typeof APPROVABLE_TEXT_BY_TYPE;
  comments?: CommentInfoFragmentType[] | null;
};

const APPROVABLE_TEXT_BY_TYPE = {
  extension_offer_active: {
    title: 'Extension Offer',
    subtitle: 'Created',
  },
  staffing_request_open: {
    title: 'Staffing Request',
    subtitle: 'Created',
  },
  staffing_request_update: {
    title: 'Staffing Request',
    subtitle: 'Edited',
  },
};

export const ApprovableDescription = ({
  id,
  approvalDocument,
  actionType,
  comments,
}: Props) => {
  const { title, subtitle } = APPROVABLE_TEXT_BY_TYPE[actionType];

  const posts = comments?.map((comment) => {
    return {
      id: comment.id,
      message: comment.contentAsText,
      time: comment.updatedAt,
      name: comment.author.name,
      external: false,
    };
  });

  return (
    <Space size={8} direction="vertical" style={{ width: '100%' }}>
      <Space size={4} style={{ height: 32 }}>
        <Text weight="bold">{title}</Text>
        <Text size="sm" weight="light" color="midnightLighter">
          {subtitle}
        </Text>
      </Space>
      {approvalDocument && (
        <ApprovalChainsAttachmentsDrawerTrigger
          approvalChainId={id}
          approvalDocumentFilename={approvalDocument?.filename}
        />
      )}
      {posts && posts.length > 0 && <Conversation posts={posts} />}
    </Space>
  );
};
